import request from '@/util/request'

/**
 * 提交
 */
export function order (params) {
  return request({
    url: `/api/sale/website/order`,
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/payment.js